/**
 * Типографика посадочных страниц. Она крупнее интерфейсной: такую страницу читают сплошняком, а
 * не сканируют глазами по элементам управления. Палитра при этом общая — цвета берутся из
 * токенов темы, а не задаются числами.
 */

/** Заголовок первого экрана. Размер тянется за шириной окна, поэтому задан через clamp(). */
export const display = 'text-[clamp(34px,4.6vw,62px)] leading-[1.08] font-semibold tracking-[-0.026em] text-balance'

/** Заголовок раздела. */
export const sectionTitle = 'text-[clamp(28px,3.4vw,42px)] leading-[1.15] font-semibold tracking-[-0.022em]'

/** Подзаголовок раздела и вводный абзац первого экрана. */
export const lead = 'text-[17px] leading-[1.65] sm:text-[18px]'

/** Основной текст карточек. */
export const bodyText = 'text-[15px] leading-[1.6] sm:text-[15.5px]'

/** Приписка мелким шрифтом: подпись под цифрой, сноска в карточке шага. */
export const noteText = 'text-[13px] leading-[1.5]'

/** Надзаголовок прописными: «Каталог Evirma», «Аудитория», названия показателей. */
export const eyebrow = 'text-[12px] leading-[16px] font-semibold uppercase tracking-[0.08em]'

/** Цифры выравниваются по разрядам: так столбцы показателей стоят ровно, как в накладной. */
export const figure = 'text-[clamp(32px,3.2vw,40px)] leading-[1.1] font-semibold tabular-nums tracking-[-0.03em]'

/** Приглушённый текст лендинга темнее интерфейсного: длинные абзацы читают, а не проглядывают. */
export const mutedText = 'text-section-foreground'

/** Ширина содержимого и боковые отступы одинаковы во всех секциях страницы. */
export const container = 'mx-auto w-full max-w-[1200px] px-5 sm:px-6 lg:px-8'
